import React from 'react'
import ReactDOM from 'react-dom'
import App from 'src/core/app'
import { AppContainer } from 'react-hot-loader'
const render = Component => {
  ReactDOM.render(
    <AppContainer>
      <Component />
    </AppContainer>,
    document.getElementById('root')
  )
}

render(App)
if (module.hot) {
  module.hot.accept('src/core/app', () => { render(App) })
}



// WEBPACK FOOTER //
// ./core/index.js